/**
 * Las 32 entidades federativas, para el domicilio fiscal.
 *
 * Karin: «nuevo cliente - en estados poner un select con la lista de
 * estados de mexico para facilitar la selección».
 *
 * ── Por qué una lista y no un catálogo ──────────────────────────────
 *
 * Esto no es el catálogo de «estados» del sistema. Ése son las plazas en
 * las que APRISA opera —Tabasco, Tapachula, Tuxtla Gutiérrez— y algunas
 * no son entidades federativas; sirve para despachar técnicos y repartir
 * zonas. Esta lista es la del domicilio fiscal del cliente, que va al
 * CFDI y tiene que decir lo que dice el SAT.
 *
 * Y es una lista fija y no una tabla porque no cambia: son las 32 de la
 * Constitución, y el día que cambien va a ser noticia nacional y no una
 * fila que alguien edite en Administración.
 *
 * ── Por qué importa la ortografía ───────────────────────────────────
 *
 * Era un campo de texto libre, y de ahí sale lo que se imprime en la
 * factura. «Edo. de México», «Estado de México», «MEXICO» y «Méx.» son el
 * mismo estado y cuatro cadenas distintas, y la que llegue al CFDI es la
 * que alguien tecleó ese día. Con un desplegable hay una sola forma de
 * escribir cada uno.
 *
 * Se escriben como los nombra el SAT en su catálogo de entidades, con
 * acentos: es lo que va en el comprobante.
 */
export const ESTADOS_DE_MEXICO: string[] = [
  'Aguascalientes',
  'Baja California',
  'Baja California Sur',
  'Campeche',
  'Chiapas',
  'Chihuahua',
  'Ciudad de México',
  'Coahuila de Zaragoza',
  'Colima',
  'Durango',
  'Guanajuato',
  'Guerrero',
  'Hidalgo',
  'Jalisco',
  'México',
  'Michoacán de Ocampo',
  'Morelos',
  'Nayarit',
  'Nuevo León',
  'Oaxaca',
  'Puebla',
  'Querétaro',
  'Quintana Roo',
  'San Luis Potosí',
  'Sinaloa',
  'Sonora',
  'Tabasco',
  'Tamaulipas',
  'Tlaxcala',
  'Veracruz de Ignacio de la Llave',
  'Yucatán',
  'Zacatecas',
];

/**
 * Si ese texto es uno de los 32, comparado con manga ancha.
 *
 * Sirve para decidir si lo que ya estaba guardado cabe en el desplegable
 * o hay que ofrecerlo aparte: hay clientes dados de alta con «MEXICO» o
 * «Edo. de México», y un desplegable que no incluya el valor guardado
 * arranca enseñando un hueco y lo borra al primer guardado.
 */
export function elEstadoQueEs(texto: string | null | undefined): string | null {
  const buscado = normalizar(texto ?? '');
  if (!buscado) return null;

  return ESTADOS_DE_MEXICO.find((e) => normalizar(e) === buscado) ?? null;
}

function normalizar(valor: string): string {
  return valor
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim();
}
